import { observable } from "mobx";
import { Api } from "./Api";
import { CommonsStore } from "../model/CommonsStore";
import { Schema } from "./Schema";
import { Logger, LoggerFactory } from "../logger";
import { DataSource, FindAllParams } from "./DataSource";
import { unionBy } from "lodash";
import { RemoteOneDataSource } from "./RemoteOneDataSource";
import { RemoteListDataSource } from "./RemoteListDataSource";

export interface RemoteDataSourceOptions {
  api: Api;
  name: string;
  schema: Schema;
  url: string;
  commons: CommonsStore;
  params?: FindAllParams;
}

export type RemoteOneDataSourceOptions = RemoteDataSourceOptions;

export class RemoteDataSource<T, ID> implements DataSource<T, ID> {
  public name: string;
  public schema: Schema;
  public api: Api;
  public url: string;
  @observable public commons: CommonsStore;
  @observable public oneDataSource!: RemoteOneDataSource<T, ID>;
  @observable public listDataSource!: RemoteListDataSource<T, ID>;
  protected log: Logger;

  public static clone<X, Y>(
    old: RemoteDataSource<X, Y>,
    options?: Partial<RemoteDataSourceOptions>
  ) {
    options = options || {};
    return RemoteDataSource.create<X, Y>({
      api: options.api || old.api,
      name: options.name || old.name,
      schema: options.schema || old.schema,
      url: options.url || old.url,
      commons: options.commons || old.commons,
      params: options.params || old.listDataSource.params
    });
  }

  public static create<T, ID>(
    options: RemoteDataSourceOptions
  ): RemoteDataSource<T, ID> {
    const it = new RemoteDataSource<T, ID>(options);

    it.listDataSource = new RemoteListDataSource(options);
    it.oneDataSource = new RemoteOneDataSource(options);

    return it;
  }

  protected constructor(options: RemoteDataSourceOptions) {
    const { name, api, url, schema } = options;
    this.api = api;
    this.url = url;
    this.schema = schema;
    this.name = name;
    this.log = LoggerFactory.create(`RemoteDataSource [${name}]`);
    this.commons = options.commons!;
  }
}

export const defaultsMerger = (
  objValue: any,
  srcValue: any,
  key: string,
  ...rest: any[]
): any => {
  if (key === "filters") {
    return unionBy(srcValue, objValue, "field");
  }
};
